<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <Table :datas="employeeList" :border="true" :loading="loading">
      <TableItem title="编码" prop="code" :width="150"></TableItem>
      <TableItem title="姓名" prop="name"></TableItem>
      <TableItem title="部门" prop="dept"></TableItem>
      <TableItem title="入职日期" :width="120">
        <template slot-scope="{data}">
          {{ dateFormat(data.entryDate) }}
        </template>
      </TableItem>
      <TableItem title="状态" :width="80" align="center">
        <template slot-scope="{data}">
          {{ data.status === 2 ? '离职' : '在职' }}
        </template>
      </TableItem>
      <TableItem title="操作" :width="120">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)">编辑</span>
          <span @click="remove(data)">删除</span>
        </div>
      </TableItem>
    </Table>

    <!--新增/编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">员工档案</div>
      <Form ref="form" v-width="420" :labelWidth="110" :model="form" :rules="validationRules">
        <FormItem label="编码" prop="code">
          <input type="text" v-model="form.code">
        </FormItem>
        <FormItem label="姓名" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="部门" prop="dept">
          <input type="text" v-model="form.dept">
        </FormItem>
        <FormItem label="入职日期" prop="entryDate">
          <DatePicker type="date" v-model="form.entryDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
        <FormItem label="状态" prop="status">
          <Select v-model="form.status" :datas="statusDict" keyName="key" titleName="title"></Select>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

const emptyForm = {
  code: '',
  name: '',
  dept: '',
  entryDate: null,
  status: 1
};

export default {
  name: "SalaryEmployee",
  data() {
    return {
      employeeList: [],
      statusDict: [{key: 1, title: '在职'}, {key: 2, title: '离职'}],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['name']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.salary.employee.list().then(({data}) => {
        this.employeeList = data || [];
      }).finally(() => this.loading = false);
    },
    dateFormat(val) {
      return val ? moment(val).format('YYYY-MM-DD') : '';
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        let data = Object.assign({}, this.form);
        if (data.entryDate) {
          data.entryDate = moment(data.entryDate).format('YYYY-MM-DD');
        }
        this.$api.salary.employee[data.id ? 'update' : 'save'](data).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm(`确认删除员工[${data.name}]?`).then(() => {
        this.$api.salary.employee.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
